import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const PilotChannelLogoContainer = styled.div<React.CSSProperties>`
    position: ${(props) => props.position || 'absolute'};
    bottom: ${222 * Screen.widthRatio}px;
    left: ${165 * Screen.widthRatio}px;
    height: ${90 * Screen.widthRatio}px;
    width: ${90 * Screen.widthRatio}px;
}
`;

export default PilotChannelLogoContainer;
